/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Credits_No_CreditsInputs */

const en_admin_credits_no_credits = /** @type {(inputs: Admin_Credits_No_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No credit records yet`)
};

/**
* | output |
* | --- |
* | "No credit records yet" |
*
* @param {Admin_Credits_No_CreditsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_credits_no_credits = /** @type {((inputs?: Admin_Credits_No_CreditsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Credits_No_CreditsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_credits_no_credits(inputs)
});
export { admin_credits_no_credits as "admin.credits.no_credits" }